<template>
  <div>
    <PreLoaderSection v-if="isPreLoading" />
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Retention by Position</h1>
        <div class="section-header-right">
          <span v-html="generateActionForSectionRetention()" />
        </div>
      </div>
      <div class="section-body">
        <div class="chart-container" v-if="retentiondata || !isLoading">
          <LineChart :colors="['#7370F6']" :series="retentiondata" :categories="null" />
        </div>
        <div v-if="isLoading" class="spinner-container">
          <div class="spinner-border" role="status" />
        </div>
      </div>
    </Section>
<!--     <Section
      class="section-graph"
      :helperText="generateActionForSectionRetention()"
      :title="'Retention by Position'"
      v-if="!isPreLoading"
    >
      <div class="chart-container" v-if="retentiondata || !isLoading">
        <LineChart :colors="['#7370F6']" :series="retentiondata" :categories="null" />
      </div>
      <div v-if="isLoading" class="spinner-container">
        <div class="spinner-border" role="status" />
      </div>
    </Section> -->
  </div>
</template>

<script>
import { subDays, differenceInCalendarDays } from 'date-fns';
import LineChart from '@/charts/LineChart.vue';
import Section from '@/components/Section.vue';
import dateFormatter from '@/utils/dateFormatter';
import PreLoaderSection from '@/components/PreLoaderSection.vue';

export default {
  mixins: [dateFormatter],
  props: {
    isOverdays: {
      required: false,
    },
    isPreLoading: {
      required: false,
    },
    isLoading: {
      required: false,
    },
    retentiondata: {
      required: false,
    },
  },
  components: {
    LineChart,
    Section,
    PreLoaderSection,
  },
  computed: {
    videoId() {
      return this.$route.params.videoId;
    },
    last30days() {
      if (this.$route.query.endDate) {
        return this.transformDateToDisplay(
          subDays(new Date(this.$route.query.endDate), 30),
        );
      }
      return this.transformDateToDisplay(subDays(new Date(), 30));
    },
    isOver30days() {
      if (
        differenceInCalendarDays(
          new Date(),
          new Date(this.$route.query.startDate),
        ) > 30) {
        return true;
      }

      if (
        differenceInCalendarDays(
          new Date(this.$route.query.endDate),
          new Date(this.$route.query.startDate),
        ) > 30
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    generateActionForSectionRetention() {
      if (this.$route.query.range === 'forever' || this.isOver30days) {
        return `<span class='text-warning'>กำลังแสดงข้อมูลตั้งแต่วันที่ ${this.last30days}</span>`.toString();
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner-container {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
